import { render, staticRenderFns } from "./DogProfileDetails.vue?vue&type=template&id=e1f6225a"
import script from "./DogProfileDetails.vue?vue&type=script&lang=ts"
export * from "./DogProfileDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports